const initialState = {
  instances: [],
  instancesLoading: false,
  instancesError: null,

  transfers: [],
  transfersLoading: false,
  transfersError: null,

  recountQueue: [],
  recountQueueLoading: false,
  recountQueueError: null,

  warehouseLocations: null,
  warehouseLocationsLoading: false,
  warehouseLocationsError: null,

  userWarehouse: null,
  userWarehouseLoading: false,
  userWarehouseError: null
};

const wmsReducer = (state = initialState, action) => {
  switch (action.type) {
    // ---- Instances ----
    case 'FETCH_WMS_INSTANCES_REQUEST':
      return {
        ...state,
        instancesLoading: true,
        instancesError: null
      };

    case 'FETCH_WMS_INSTANCES_SUCCESS':
      return {
        ...state,
        instances: action.payload,
        instancesLoading: false,
        instancesError: null
      };

    case 'FETCH_WMS_INSTANCES_FAILURE':
      return {
        ...state,
        instancesLoading: false,
        instancesError: action.payload
      };

    case 'ADD_WMS_INSTANCE_LOCAL':
      return {
        ...state,
        instances: [...state.instances, action.payload]
      };

    case 'UPDATE_WMS_INSTANCE_LOCAL':
      return {
        ...state,
        instances: state.instances.map(instance =>
          instance.id === action.payload.id ? action.payload : instance
        )
      };

    case 'DELETE_WMS_INSTANCE_LOCAL':
      return {
        ...state,
        instances: state.instances.filter(instance => instance.id !== action.payload)
      };

    case 'REPLACE_WMS_INSTANCE_LOCAL':
      return {
        ...state,
        instances: state.instances.map(instance =>
          instance.id === action.payload.oldId ? action.payload.newInstance : instance
        )
      };

    // ---- Transfers ----
    case 'FETCH_WMS_TRANSFERS_REQUEST':
      return {
        ...state,
        transfersLoading: true,
        transfersError: null
      };

    case 'FETCH_WMS_TRANSFERS_SUCCESS':
      return {
        ...state,
        transfers: action.payload,
        transfersLoading: false,
        transfersError: null
      };

    case 'FETCH_WMS_TRANSFERS_FAILURE':
      return {
        ...state,
        transfersLoading: false,
        transfersError: action.payload
      };

    case 'ADD_WMS_TRANSFER_LOCAL':
      return {
        ...state,
        transfers: [...state.transfers, action.payload]
      };

    case 'DELETE_WMS_TRANSFER_LOCAL':
      return {
        ...state,
        transfers: state.transfers.filter(transfer => transfer.id !== action.payload)
      };

    case 'REPLACE_WMS_TRANSFER_LOCAL':
      return {
        ...state,
        transfers: state.transfers.map(transfer =>
          transfer.id === action.payload.oldId ? action.payload.newTransfer : transfer
        )
      };

    // ---- Recount Queue ----
    case 'FETCH_WMS_RECOUNT_QUEUE_REQUEST':
      return {
        ...state,
        recountQueueLoading: true,
        recountQueueError: null
      };

    case 'FETCH_WMS_RECOUNT_QUEUE_SUCCESS':
      return {
        ...state,
        recountQueue: action.payload,
        recountQueueLoading: false,
        recountQueueError: null
      };

    case 'FETCH_WMS_RECOUNT_QUEUE_FAILURE':
      return {
        ...state,
        recountQueueLoading: false,
        recountQueueError: action.payload
      };

    case 'ADD_WMS_RECOUNT_ITEM_LOCAL':
      return {
        ...state,
        recountQueue: [...state.recountQueue, action.payload]
      };

    case 'DELETE_WMS_RECOUNT_ITEM_LOCAL':
      return {
        ...state,
        recountQueue: state.recountQueue.filter(item => item.id !== action.payload)
      };

    case 'REPLACE_WMS_RECOUNT_ITEM_LOCAL':
      return {
        ...state,
        recountQueue: state.recountQueue.map(item =>
          item.id === action.payload.oldId ? action.payload.newItem : item
        )
      };

    // ---- Warehouse Locations ----
    case 'FETCH_WAREHOUSE_LOCATIONS_REQUEST':
      return {
        ...state,
        warehouseLocationsLoading: true,
        warehouseLocationsError: null
      };

    case 'FETCH_WAREHOUSE_LOCATIONS_SUCCESS':
      return {
        ...state,
        warehouseLocations: action.payload,
        warehouseLocationsLoading: false,
        warehouseLocationsError: null
      };

    case 'FETCH_WAREHOUSE_LOCATIONS_FAILURE':
      return {
        ...state,
        warehouseLocationsLoading: false,
        warehouseLocationsError: action.payload
      };

    // ---- User Warehouse ----
    case 'FETCH_USER_WAREHOUSE_REQUEST':
    case 'UPDATE_USER_WAREHOUSE_REQUEST':
      return {
        ...state,
        userWarehouseLoading: true,
        userWarehouseError: null
      };

    case 'FETCH_USER_WAREHOUSE_SUCCESS':
    case 'UPDATE_USER_WAREHOUSE_SUCCESS':
      return {
        ...state,
        userWarehouse: action.payload,
        userWarehouseLoading: false,
        userWarehouseError: null
      };

    case 'FETCH_USER_WAREHOUSE_FAILURE':
    case 'UPDATE_USER_WAREHOUSE_FAILURE':
      return {
        ...state,
        userWarehouseLoading: false,
        userWarehouseError: action.payload
      };

    default:
      return state;
  }
};

export default wmsReducer;
